import { useMutation } from '@tanstack/vue-query';
import type { User } from '~/types';

type ExclusiveInfoSeenResponse = { success: boolean; data: { exclusiveInfoSeenAt: string | null } };

// Stamps the account-level "100% Commission info seen" flag (ID-118). Background call: a failure
// only means the modal may show once more, so it never raises a banner.
export const useMarkExclusiveInfoSeen = () => {
  const authStore = useAuthStore();

  return useMutation({
    mutationFn: () =>
      $fetch<ExclusiveInfoSeenResponse>('/api/user/exclusive-info-seen', {
        method: 'POST',
        headers: { Authorization: `Bearer ${authStore.token}` },
      }),
    onSuccess: (res) => {
      if (authStore.user)
        authStore.updateUser({ ...authStore.user, exclusiveInfoSeenAt: res.data.exclusiveInfoSeenAt } as User);
    },
  });
};
